<template slot-scope="scope">
  <!-- 服务范围选择弹窗 -->
      <dialogModel
        title="编辑企业详情"
        :visible.sync="EnterpriseDetails"
        @handleClose="handleCloseEnterpriseDetails"
        @handleOk="handelEnterpriseDetails"
      >
        <div class="main-body">
          <div class="MajorItems">
            编辑企业详情 富文本编辑器位置
          </div>
        </div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    EnterpriseDetails: {},
  },
  components: {},
  data() {
    return {};
  },

  computed: {},
  created() {},
  methods: {
    // 关闭弹窗
    handleCloseEnterpriseDetails() {
      this.$emit("handleCloseEnterpriseDetails");
    },
    handelEnterpriseDetails() {
      this.$emit("EnterpriseDetailsDio");
    },
  },
};
</script>

<style scoped lang="less">
// 调整对话框
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 25px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
      margin-right: 15px;
    }
  }
  .Instructions {
    font-size: 12px;
    color: #999999;
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    font-weight: 400;
    text-indent: 20px;
  }
}
</style>
